module.exports = __webpack_public_path__ + "img/certification-origin2.ec09cacb.png";